import {api, handleApiError, ServiceResponse} from "../ApiClient";

export interface ReviewResource {
    message: string
    rating: number
    shareMessageWithCaddie: boolean
    attributes: string[]
    associations: ReviewAssociationResource[]
}

export interface ReviewAssociationResource {
    associationId: string
    associationType: string
}

export interface Review extends ReviewResource {
    id: string
}

export interface GetReviewResponse {
    review?: Review
    error?: string
}

export interface CreateReviewResponse extends ServiceResponse {
    review?: Review
}

export const ReviewService = () => {

    const create = async (resource: ReviewResource): Promise<CreateReviewResponse> => {
        return api.post<Review>(`/api/1/reviews`, resource)
            .then((resp) => {
                if (resp && resp.status === 200) {
                    return {
                        review: resp.data
                    }
                }

                return handleApiError(resp)
            })
            .catch(handleApiError)
    }

    return {
        createReview: create,
    }
}
